import CartItem from "emun.cart/cart-item.model";
import shoppingConfig from "emun.shopping/shopping.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import cacheBusterGuid from "webutils/services/cache-buster-guid";

export default class OrderConfirmationController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.crmMode = $ctrl.$cart.isInCrm();
    $ctrl.shoppingConfig = shoppingConfig;
    let options = {
      url: "QueryCarts.json?IncludeProducts=1",
      take: 1,
      criteria: {
        id: $ctrl.orderNumber,
        token: $ctrl.selfcheckout ? "GUESTCHECKOUT" : undefined,
      },
      autoLoad: true,
      onLoaded: (args) => {
        args.first.items = args.first.items.map((item) => new CartItem(item));
        $ctrl.order = args.first;
        $ctrl.bus.send("QueryCarts.json?MultiCartId=" + $ctrl.order.multiCartId).then((res) => {
          $ctrl.sessionOrders = res.data.results;
        });

        $ctrl.qrCodeData = "https://api.qrserver.com/v1/create-qr-code/?data=" + $ctrl.order.id + "&amp;size=300x300"
        $ctrl.qrCodeData =
          "https://chart.googleapis.com/chart?chl=" +
          $ctrl.order.id +
          "&cht=qr&choe=UTF-8&chs=300x300";

        if ($ctrl.shoppingConfig.writeOrderDataWindowObject) {
          $ctrl.itemData = [];
          $ctrl.order.items.map((m) => {
            $ctrl.itemData.push({
              name: m.description,
              price: m.pricePaid,
              sku: m.productId,
            });
          });
          window.orderData = {
            orderId: $ctrl.order.id,
            cartTotal: $ctrl.order.subTotal,
            items: $ctrl.itemData,
            cartCoupon: $ctrl.order.promoCode,
            phone:
              '<a href="tel:' +
              $ctrl.order.billingLocation.phone +
              '" target="_blank">' +
              $ctrl.order.billingLocation.phone +
              "</a>",
            email:
              '<a href="mailto:' +
              $ctrl.order.purchaser.email +
              '" target="_blank">' +
              $ctrl.order.purchaser.email +
              "</a>",
          };
        }
        if ($ctrl.shoppingConfig.writeOrderDataAcoustic) {
          //Accoustic
          ewt.cot({
            action: "Purchase",
            detail: $ctrl.order.id,
            amount: $ctrl.order.grandTotal.toString(),
          });
        }
      },
    };
    $ctrl.toEmail = "";
    $ctrl.query = new AutoQuery(options);
    $ctrl.bus = $ctrl.query.bus;

    $ctrl.printUrl = $appConfig.resolveServiceUrl(
      "SalesOrderPrint/" +
        $ctrl.orderNumber +
        "?OutputType=PortableDocFormat" +
        cacheBusterGuid()
    );
    $ctrl.printMultiUrl = $appConfig.resolveServiceUrl(
      "SalesOrderPrint?OrderNumbers=" +
        $ctrl.orderNumbers +
        "?OutputType=PortableDocFormat" +
        cacheBusterGuid()
    );
    $ctrl.printImagesUrl = $appConfig.resolveServiceUrl(
      "SalesOrderPrint/" +
        $ctrl.orderNumber +
        "?OutputType=PortableDocFormat&IncludeImages=True" +
        cacheBusterGuid()
    );
    $ctrl.printMultiImagesUrl = $appConfig.resolveServiceUrl(
      "SalesOrderPrint?OrderNumbers=" +
        $ctrl.orderNumbers +
        "?OutputType=PortableDocFormat&IncludeImages=True" +
        cacheBusterGuid()
    );
  }

  close() {
    const $ctrl = this;
    $ctrl.$cart.removeOrderFromSession($ctrl.$cart.id);
    if ($ctrl.selfcheckout) $ctrl.$state.transitionTo("guest-checkout");
    else $ctrl.backToOrders();
  }

  backToOrders() {
    const cart = this.$cart;
    let $ctrl = this;
    if (!cart.goToFirstOrder()) {
      cart.reset();
      if ($ctrl.$session.isShowroom()) $ctrl.$state.transitionTo("home");
      else $ctrl.$state.transitionTo("orders");
    }
  }

  emailOrder() {
    const $ctrl = this;
    const request = {
      cartId: $ctrl.orderNumber,
      from: null,
      to: $ctrl.toEmail,
      message: null,
      subject: $ctrl.$session.clientName + " Order #" + $ctrl.orderNumber,
    };
    $ctrl.sending = new Date();
    return $ctrl.bus
      .send("EmailOrder.json", request)
      .then(() => ($ctrl.toEmail = null))
      .finally(() => ($ctrl.sending = false));
  }

  $onDestroy() {
    const $ctrl = this;
    $ctrl.query.dispose();
  }
}
